<template>
  <v-menu v-model="menu" :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-row
        v-bind="props"
        :class="`${dirtyClass} center-field`"
        style="cursor: pointer"
        no-gutters
      >
        <v-col>
          <span class="pl-1 span-field">{{ item[parameter] }}</span>
        </v-col>
        <v-col>
          <div class="float-right" :style="swatchStyle" />
        </v-col>
      </v-row>
    </template>
    <v-card v-if="editable">
      <v-card-text class="pa-0">
        <v-color-picker
          :model-value="color"
          mode="hex"
          :disabled="disabled"
          @update:model-value="
            $emit('update'),
              $emit('set', {
                item: item,
                value: $event,
                parameter: parameter
              })
          "
        ></v-color-picker>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ColorPickerField',
  props: {
    parameter: { required: true },
    item: { required: true },
    disabled: { default: false, required: false },
    editable: { default: true, required: false },
    dirtyClass: { required: false }
  },
  data: () => ({
    menu: false
  }),
  computed: {
    swatchStyle() {
      const { color, menu } = this
      return {
        backgroundColor: color,
        height: '20px',
        width: '20px',
        borderRadius: menu && this.editable ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    color: {
      get() {
        return this.item[this.parameter]
      }
    }
  }
}
</script>

<style scoped>
.center-field {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
